import React from 'react';
import { cardStyles } from '../../styles/tailwind.classes';

const Card = ({ 
  variant = 'default', 
  className = '', 
  children, 
  ...props 
}) => {
  return (
    <div
      className={`${cardStyles.base} ${cardStyles[variant]} ${className}`}
      {...props}
    >
      {children}
    </div>
  );
};

export default Card; 